/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  CREATE_SKILL_BASED_QUEUE,
  READ_SKILL_BASED_QUEUE,
  READ_SKILL_BASED_QUEUES_LIST,
  UPDATE_SKILL_BASED_QUEUE,
} from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';
import SkillBasedQueueList from 'domain/gpo/skillBasedQueue/List';
import { CreateSkillBasedQueue, UpdateSkillBasedQueue } from 'domain/gpo/skillBasedQueue/createupdate';
import ViewSkillBasedQueue from 'domain/gpo/skillBasedQueue/Show';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import SkillBasedQueueContext from 'domain/gpo/skillBasedQueue/SkillBasedQueueContext';
import { SKILL_BASED_QUEUE_PATH, useSkillBasedQueueRoute } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';

const SkillBasedQueueRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createEntityRoute,
    updateRoute,
    copyEntityRoute,
  } = useSkillBasedQueueRoute();

  return (
    <ProtectedRouter basePath={SKILL_BASED_QUEUE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_SKILL_BASED_QUEUES_LIST}>
              <SkillBasedQueueList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_SKILL_BASED_QUEUE}>
              <CreateSkillBasedQueue />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={copyEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_SKILL_BASED_QUEUE}>
              <CreateSkillBasedQueue />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <SkillBasedQueueContext permissionToCheck={READ_SKILL_BASED_QUEUE}>
              <ViewSkillBasedQueue />
            </SkillBasedQueueContext>
          }
        />

        <Route
          path={updateRoute}
          element={
            <SkillBasedQueueContext permissionToCheck={UPDATE_SKILL_BASED_QUEUE}>
              <UpdateSkillBasedQueue />
            </SkillBasedQueueContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

SkillBasedQueueRouter.getRouterPath = () => `${SKILL_BASED_QUEUE_PATH}/*`;

export default SkillBasedQueueRouter;
